import styled from "@emotion/styled";
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { TextField } from "@shared/components/TextField";
import { blurActiveElement } from "@shared/utils/blur-active-element";

const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 180px;
  align-items: flex-end;
  gap: 1rem;
  margin-bottom: 0.5rem;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }
`;

export type EnabledFilter = "all" | "enabled" | "disabled";

export type SubscriptionsAuditFilterValues = {
  userId: string;
  enabledFilter: EnabledFilter;
};

type Props = {
  values: SubscriptionsAuditFilterValues;
  onChange: (values: SubscriptionsAuditFilterValues) => void;
};

export const SubscriptionsAuditFilters = (props: Props) => {
  const { values, onChange } = props;
  const [userIdInput, setUserIdInput] = useState(values.userId);

  const debouncedUserIdChange = useDebouncedCallback((userId: string) => {
    onChange({ ...values, userId });
  }, 800);

  const handleUserIdInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setUserIdInput(event.target.value);
    debouncedUserIdChange(event.target.value);
  };

  const clearUserIdFilter = () => {
    debouncedUserIdChange.cancel();
    setUserIdInput("");
    onChange({ ...values, userId: "" });
    blurActiveElement();
  };

  return (
    <FiltersContainer>
      <TextField
        name="userId"
        label="Owner user ID"
        placeholder="Filter by user ID"
        value={userIdInput}
        onChange={handleUserIdInputChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <IconButton size="small" onClick={clearUserIdFilter}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <FormControl>
        <InputLabel id="enabled-filter-label">Status</InputLabel>
        <Select
          labelId="enabled-filter-label"
          label="Status"
          value={values.enabledFilter}
          onChange={(event) =>
            onChange({
              ...values,
              enabledFilter: event.target.value as EnabledFilter,
            })
          }
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="enabled">Enabled</MenuItem>
          <MenuItem value="disabled">Disabled</MenuItem>
        </Select>
        <FormHelperText> </FormHelperText>
      </FormControl>
    </FiltersContainer>
  );
};
